import TemplateAuthentication from "../components/UI/TemplateAuthentication";
import AuthHeader from "../components/Auth/AuthHeader";
import { Form, Formik } from "formik";
import {
  signUpInfosSchema,
  signUpInfosInitialValues,
  type SignUpInfosValues,
} from "../models/signup";
// @ts-expect-error pure js
import { handleAPIError } from "../utils";
import { useState } from "react";
// @ts-expect-error pure js
import useAuthenticatedAxios from "../hooks/use-authenticated-axios";
// @ts-expect-error pure js
import { sanitizeValues } from "../models/utils";
import { useLocation, useNavigate } from "react-router-dom";
import { trackMetaEvent } from "../utils/metaPixel";
import { trackEvent } from "../utils/tracking";
// @ts-expect-error pure js
import useAuth from "../hooks/use-auth.js";
import PageLayout from "../components/UI/Layout/PageLayout";
import SignupSteps from "../components/Auth/SignupSteps";
import {
  NameFields,
  BailleurDetailsFields,
} from "../components/Auth/SignupBailleurFields";

export default function TBDPage() {
  const [error, setError] = useState("");
  const axios = useAuthenticatedAxios();
  const { buildAndSetAuth } = useAuth();
  const nav = useNavigate();
  const location = useLocation();

  async function signMeUp(values: SignUpInfosValues) {
    try {
      setError("");
      const response = await axios.put(
        "/signup/verify-tbd",
        sanitizeValues(values),
      );
      buildAndSetAuth(response.data);
      trackMetaEvent("CompleteRegistration", `reg_${response.data.id_compte}`);
      trackEvent("CompleteRegistration", location, {
        event_id: `reg_${response.data.id_compte}`,
        user_data: { email: response.data.mail },
      });
      nav(response.data.home);
    } catch (err: unknown) {
      setError(handleAPIError(err));
    }
  }

  return (
    <PageLayout isTBD>
      <TemplateAuthentication>
        <Formik
          initialValues={signUpInfosInitialValues}
          validationSchema={signUpInfosSchema}
          onSubmit={signMeUp}
        >
          {({ values }) => (
            <Form>
              <AuthHeader
                title="Informations complémentaires"
                subtitle="Veuillez compléter votre profil pour continuer."
              />
              <SignupSteps id="tbd" error={error}>
                <NameFields />
                {values.home === "/bailleur" && <BailleurDetailsFields />}
              </SignupSteps>
            </Form>
          )}
        </Formik>
      </TemplateAuthentication>
    </PageLayout>
  );
}
